import { addGoodsCart, getGoodsCart, addAllGoodsCart, addbuyAgain, goodAddSkill,goodAddPackage } from "@/api/goods";
import { getNavBar } from "@/api/commonApi";
import { homeNavBarRoute } from "@/components/nav/staticData";
import { behaviorshopCart } from '@/api/apiPot.js'
// 获取秒杀数据
export const loadSeckillsInfo = ({ commit }) => {
    return new Promise((resolve, reject) => {
        const data = [

        ];
        const date = new Date();
        const hours = date.getHours();
        const minute = date.getMinutes();
        const seconds = date.getSeconds();
        /* console.log([hours, minute, seconds]);*/
        // 距离开始秒杀时间
        const deadline = {
            hours: 1,
            minute: 38,
            seconds: 36
        };
        commit("SET_SECKILLS_INFO", [data, deadline]);
    });
};

// 获取轮播(营销)图片
export const loadCarouselItems = ({ commit }) => {
    return new Promise((resolve, reject) => {
        const data = {
            /*1920*540大轮播*/
            carouselItems: ["static/img/nav/nav_1.png", "static/img/nav/nav_1.png"],
            /*每周特价轮播*/
            activity: [
                "static/img/nav/nav_showimg1.jpg",
                "static/img/nav/nav_showimg2.jpg"
            ]
        };
        commit("SET_CAROUSELITEMS_INFO", data);
    });
};

// 获取每周特价数据
export const loadSpecialOffer = ({ commit }) => {
    return new Promise((resolve, reject) => {
        const weekSpecial = {
            title: "每周特价",
            link: ["中药", "西药"],
            detail: [{
                itemFour: [{
                    categoryLabel: "高毛",
                    img: "static/img/index/computer/item-computer-2.jpg",
                    title: "医用酒精消毒液",
                    spec: "60ml/瓶/盒",
                    intro: "笔记本999元限量秒！",
                    realPrice: "￥89.6",
                    speedProgress: "60"
                }],
                itemFourOther: [{
                    categoryLabel: "高毛",
                    img: "static/img/index/computer/item-computer-2.jpg",
                    title: "医用酒精消毒液",
                    spec: "60ml/瓶/盒",
                    intro: "笔记本999元限量秒！",
                    realPrice: "￥89.6",
                    speedProgress: "60"
                }],
                itemContent: [
                    "static/img/index/computer/item-computer-2-6.jpg",
                    "static/img/index/computer/item-computer-2-7.jpg",
                    "static/img/index/computer/item-computer-2-8.jpg"
                ]
            }]
        };
        const date = new Date();
        const hours = date.getHours();
        const minute = date.getMinutes();
        const seconds = date.getSeconds();
        /*    console.log([hoursTime, minuteTime, secondsTime]);*/
        // 距离开始秒杀时间
        const weekDeadline = {
            hours: 2,
            minute: 48,
            seconds: 46
        };
        commit("SET_WEEKLY_SPECIAL_INFO", [weekSpecial, weekDeadline]);
        console.log(1, weekDeadline);
    });
};

// 商品添加-添加购物车 商品模块专用
export const addGoodsShoppingCart = ({ commit }, goods) => {
    return new Promise((resolve, reject) => {
        addGoodsCart(goods)
            .then(res => {
                const data = res.data;
                // 刷新购物车
                console.log('-----this.$route.query',);
                behaviorshopCart({goods_id:goods.goods_id,num:goods.quantity || 1,source:sessionStorage.getItem('searchItem')||'',is_view_details:goods.is_view_details || 0})

                this.loadShoppingCart({ commit });
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
};
// 添加购物车
export const addShoppingCart = ({ commit }, goods) => {
    return new Promise((resolve, reject) => {
        addGoodsCart(goods)
            .then(res => {
                const data = res.data;
                behaviorshopCart({goods_id:goods.goods_id,num:goods.quantity||1,source:sessionStorage.getItem('searchItem')||''})
                // 刷新购物车
                this.loadShoppingCart({ commit });
              /*  commit("ADD_SHOPPING_CART", goods);*/
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
        // commit("ADD_SHOPPING_CART", data);
    });
};

// 我的订单再次购买添加购物车
export const addbuyAgainCart = ({ commit }, goods) => {
    return new Promise((resolve, reject) => {
        addbuyAgain(goods)
            .then(res => {
                const data = res.data;
                // 刷新购物车
                this.loadShoppingCart({ commit });
                commit("ADD_SHOPPING_CART", goods);
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
        // commit("ADD_SHOPPING_CART", data);
    });
};

//我的收藏多选加入购物车
export const addAllShoppCart = ({ commit }, goods) => {
    console.log(goods.validCartList);
    return new Promise((resolve, reject) => {
        addAllGoodsCart(goods.checkAllGroups)
            .then(res => {
                const data = res.data;
                //刷新购物车
                this.loadShoppingCart({ commit });
               /* commit("ADD_SHOPPING_CART", goods.validCartList);*/
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//秒杀加入购物车
export const goodAddSkillCart = ({ commit }, goods) => {
    return new Promise((resolve, reject) => {
        goodAddSkill(goods)
            .then(res => {
                const data = res.data;
                // 刷新购物车
                this.loadShoppingCart({ commit });
                commit("ADD_SHOPPING_CART", goods);
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
        // commit("ADD_SHOPPING_CART", data);
    });
};
//套餐加入购物车
export const goodAddPackageCart = ({ commit }, goods) => {
    return new Promise((resolve, reject) => {
        goodAddPackage(goods)
            .then(res => {
                const data = res.data;
                // 刷新购物车
                this.loadShoppingCart({ commit });
                /*commit("ADD_SHOPPING_CART", goods);*/
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
        // commit("ADD_SHOPPING_CART", data);
    });
};

// 获取用户推荐
export const loadRecommend = ({ commit }) => {
    return new Promise((resolve, reject) => {
        const data = [
            [{
                    img: "static/img/otherBuy/1.jpg",
                    intro: "iPhone7/6s/8钢化膜苹果7Plus全屏全覆盖3D抗蓝",
                    price: 29.0
                },
                {
                    img: "static/img/otherBuy/2.jpg",
                    intro: "苹果数据线 苹果iPhoneX/6s/7plus/8充电线",
                    price: 36.0
                },
                {
                    img: "static/img/otherBuy/3.jpg",
                    intro: "苹果8/7/6/6s钢化膜 iphone8/7/6s/6钢化玻璃",
                    price: 19.0
                },
                {
                    img: "static/img/otherBuy/4.jpg",
                    intro: "iPhone6s/7钢化膜苹果8 Plus手机膜抗蓝光非全屏",
                    price: 28.0
                }
            ],
            [{
                    img: "static/img/otherBuy/5.jpg",
                    intro: "苹果6s手机壳iPhone6s Plus保护壳防摔全",
                    price: 28.0
                },
                {
                    img: "static/img/otherBuy/6.jpg",
                    intro: "iPhone7/8手机壳手机套防摔磨砂保护壳星空黑☆全包保护",
                    price: 30.0
                },
                {
                    img: "static/img/otherBuy/7.jpg",
                    intro: "数据线 适用于苹果iPhone 6s/6plus/7plus/8/X",
                    price: 18.0
                },
                {
                    img: "static/img/otherBuy/8.jpg",
                    intro: "iPhone8/7/6S/6钢化膜 苹果8/7/6s/6玻璃膜 手机高",
                    price: 15.0
                }
            ]
        ];
        commit("SET_RECOMMEND_INFO", data);
    });
};

export const loadAddress = ({ commit }) => {
    return new Promise((resolve, reject) => {
        const address = [{
                addressId: "123456",
                name: "Gavin",
                province: "广东省",
                city: "广州市",
                area: "天河区",
                address: "燕岭路633号",
                phone: "152****0609",
                postalcode: "510000"
            },
            {
                addressId: "123458",
                name: "Kevin",
                province: "上海市",
                city: "上海市",
                area: "浦东新区",
                address: "沙新镇",
                phone: "158****0888",
                postalcode: "200120"
            }
        ];
        commit("SET_USER_ADDRESS", address);
    });
};
// 获取购物车数据
export const loadShoppingCart = ({ commit }) => {
    return new Promise((resolve, reject) => {
        getGoodsCart()
            .then(res => {
                console.log("购物车数据", res);
                const data = res.data; //秒杀购物车-skill  普通购物车-general  专区买赠换购商品-show_goods_zp
                commit("SET_SHOPPING_CART", data);
                
                resolve(data);
            })
            .catch(error => {
                reject(error);
            });

    });
};

// 添加注册用户
export const addSignUpUser = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        const userArr = localStorage.getItem("users");
        let users = [];
        if (userArr) {
            users = JSON.parse(userArr);
        }
        users.push(data);
        localStorage.setItem("users", JSON.stringify(users));
    });
};

// 用户登录
export const login = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        if (data.username === "Gavin" && data.password === "123456") {
            localStorage.setItem("loginInfo", JSON.stringify(data));
            commit("SET_USER_LOGIN_INFO", data);
            resolve(true);
            return true;
        }
        const userArr = localStorage.getItem("users");
        console.log(userArr);
        if (userArr) {
            const users = JSON.parse(userArr);
            for (const item of users) {
                if (item.username === data.username) {
                    localStorage.setItem("loginInfo", JSON.stringify(item));
                    commit("SET_USER_LOGIN_INFO", item);
                    resolve(true);
                    break;
                }
            }
        } else {
            resolve(false);
        }
    });
};

// 退出登录
export const signOut = ({ commit }) => {
    localStorage.removeItem("loginInfo");
    commit("SET_USER_LOGIN_INFO", {});
};

// 判断是否登录
export const isLogin = ({ commit }) => {
    const user = localStorage.getItem("loginInfo");
    if (user) {
        commit("SET_USER_LOGIN_INFO", JSON.parse(user));
    }
};

/**获取导航栏数据 */
export const getNavbarData = ({ commit }) => {
    console.log("----获取导航栏数据-------");
    return new Promise((resolve, reject) => {
        getNavBar()
            .then(res => {
                console.log("获取导航栏", res);
                if (res.data) {
                    // res.data.forEach(element => {
                    //     let nav = homeNavBarRoute.find(nav => {
                    //         return nav.id === element.id + "";
                    //     });
                    //     element.path = nav ? nav.path : "";
                    // });
                    let navData = res.data;
                    let homeItem = {
                        id: "0",
                        name: "首页",
                        url: "/",
                        path: "/",
                        pc_url:'/'
                    };
                    navData.unshift(homeItem);

                    commit("SET_NAV_DATA", navData);
                    resolve(navData);
                }
            })
            .catch(err => {
                reject(err);
            });
    });
};

// 设置当前选中的nav
export const setCurNavId = ({ commit }, id) => {
    commit("SET_CURRENT_NAV", id);
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js